import { useEffect } from "react";

type TProps = {
  isClicked: boolean | null;
  componentRef?: React.MutableRefObject<HTMLDivElement | HTMLElement | null>;
  onOutside: () => void;
};

const useDetectOutsideClick = ({
  isClicked,
  componentRef,
  onOutside,
}: TProps) => {
  const handleOutsideClick = (e: MouseEvent) => {
    if (
      componentRef?.current &&
      !componentRef.current.contains(e.target as Node)
    ) {
      if (!(e.target as HTMLElement).classList.contains("calendar")) {
        onOutside();
      }
    }
  };

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null;
    if (isClicked) {
      // Delay attaching the listener to avoid catching the opening click
      timeoutId = setTimeout(() => {
        document.addEventListener("click", handleOutsideClick);
      }, 0);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isClicked]);
};

export default useDetectOutsideClick;
